/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Container, MaterialUICore } from '@iclinic/design-system';

import { useToggleBodyClass } from 'shared/hooks';
import { Header } from 'features/onlinePayment/components/config';
import {
  getSellerType,
  isSellerCreationDone,
} from 'features/onlinePayment/state/config/register/selectors';
import SellerRegisterProfile from './SellerRegisterProfile';
import SellerRegisterBank from './SellerRegisterBank';
import useStyles from '../../styles';
import HeaderStep from 'features/onlinePayment/components/HeaderStep';
import { SellerType } from '../constants';
import { getSellerTypeFromLocalStorage } from 'features/onlinePayment/utils';

const { useTheme } = MaterialUICore;

const SellerRegister = () => {
  const isSellerDone = useSelector(isSellerCreationDone);
  const reduxSellerType = useSelector(getSellerType);

  const [resolvedSellerType, setResolvedSellerType] =
    useState<SellerType | null>(() => getSellerTypeFromLocalStorage());

  useEffect(() => {
    if (!resolvedSellerType && reduxSellerType) {
      setResolvedSellerType(reduxSellerType);
    }
  }, [reduxSellerType, resolvedSellerType]);

  const classes = useStyles();
  const theme = useTheme();
  useToggleBodyClass(classes.whiteBody, theme.breakpoints.down('sm'));

  if (!resolvedSellerType) {
    return null;
  }

  const [step, component] = !isSellerDone
    ? [1, <SellerRegisterProfile />]
    : [2, <SellerRegisterBank />];

  return (
    <Container maxWidth="lg">
      <HeaderStep type={resolvedSellerType} step={step} />
      <Header sellerType={resolvedSellerType} step={step} />
      {component}
    </Container>
  );
};

export default SellerRegister;
